import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Prescription from "./rx/Prescription";
import GlassRx from "./rx/GlassRx";
import CashTill from "./rx/CashTill";
import PurchaseOrder from "./rx/PurchaseOrder";
import ShippingManifest from "./rx/ShipmentManifest";
import Pharmacy from "./rx/Pharmacy";
import Optical from "./rx/Optical";
import OpticalJob from "./rx/OpticalJob";
import Discharge from "./rx/Discharge";
import SxPayment from "./rx/SxPayment";
import LabelPrint from "./rx/LabelPrint";
import PrescriptionNew from "./rx/PrescriptionNew";
// import RxV2 from "./rx/RxV2";
// import RxV21 from "./rx/RxV21";
import RxV21_Dispatch from "./rx/RxV21_Dispatch";
import GlassRxV2 from "./rx/GlassRxV2";
import SxPaymentBill from "./rx/SxPaymentBill";
import SxPaymentGstBill from "./rx/SxPaymentGstBill";
import SxPaymentFinalBill from "./rx/SxPaymentFinalBill";
import SxPaymentCashReciept from "./rx/SxPaymentCashReciept";
import RxV21_WR_Disha from "./rx/RxV21_Disha_Dispatch";
import SxSafetyChecklist from "./rx/SxSafetyChecklist";
import SxBedHeadChecklist from "./rx/SxBedHeadChecklist";
import DischargeV2 from "./rx/DischargeV2";
import RecieptNoteFinal from "./rx/RecieptNoteFinal";
import RxV21_WR_VT from "./rx/RxV21_Dispatch_vt";
import NeoSxBedHeadChecklist from "./rx/NeoSxBedHeadChecklist";
import NeoSxDischarge from "./rx/NeoSxDischarge";

class App extends React.Component {
  render() {
    return (
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/rxold/:visitId" element={<Prescription />}></Route>
            <Route path="/rx/:visitId" element={<PrescriptionNew />}></Route>
            {/* <Route path="/rx20/:visitId" element={<RxV2 />}></Route>
            <Route path="/rx21/:visitId" element={<RxV21 />}></Route> */}
            <Route path="/rx2/:visitId" element={<RxV21_Dispatch />}></Route>
            <Route path="/vt/rx2/:visitId" element={<RxV21_WR_VT />}></Route>
            <Route path="/disha/rx2/:visitId" element={<RxV21_WR_Disha />}></Route>
            <Route path="/glass2/:visitId" element={<GlassRxV2 />}></Route>
            <Route path="/glass/:visitId" element={<GlassRx />}></Route>
            <Route path="/cashtill/:cashTillId" element={<CashTill />}></Route>
            <Route path="/po/:poId" element={<PurchaseOrder />}></Route>
            <Route path="/rn/:poId" element={<RecieptNoteFinal />}></Route>

            <Route path="/sm/:smId" element={<ShippingManifest />}></Route>
            <Route path="/optical/job/:orderId" element={<OpticalJob />}></Route>
            <Route path="/optical/bill/:orderId" element={<Optical />}></Route>
            <Route path="/pharmacy/:orderId" element={<Pharmacy />}></Route>
            <Route path="/discharge/:sxId" element={<DischargeV2 />}></Route>
            <Route path="/sxPayment/:sxId" element={<SxPayment />}></Route>
            <Route
              path="/sxPayment/bill/:sxId" //procedure bill
              element={<SxPaymentBill />}
            ></Route>
            <Route
              path="/sxPayment/gstBill/:sxId" //gst invoice
              element={<SxPaymentGstBill />}
            ></Route>
            <Route
              path="/sxPayment/finalBill/:sxId" //summary bill
              element={<SxPaymentFinalBill />}
            ></Route>
            <Route
              path="/sxPayment/cashReciept/:sxId/:index" //summary bill
              element={<SxPaymentCashReciept />}
            ></Route>
            <Route
              path="/sx/bedHeadChecklist/:sxId" //beadhead checklist
              element={<SxBedHeadChecklist />}
            ></Route>
            <Route
              path="/neo/sx/bedHeadChecklist/:sxId" //beadhead checklist
              element={<NeoSxBedHeadChecklist />}
            ></Route>
            <Route
              path="/neo/sx/discharge/:sxId" //beadhead checklist
              element={<NeoSxDischarge />}
            ></Route>
            <Route
              path="/sx/safetyChecklist/:sxId" //safety checklist
              element={<SxSafetyChecklist />}
            ></Route>
            <Route path="/label/:rnId" element={<LabelPrint />}></Route>
          </Routes>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
